import React from "react";
import { createFarceRouter } from "found";
import { BrowserProtocol } from "farce";
import { Resolver } from "found-relay";
import queryTypeMiddleware from "farce-query-type";
import enviroment from "../environment";
import routeConfig from "./routes";

const FarceRouter = createFarceRouter({
  historyProtocol: new BrowserProtocol(),
  historyMiddlewares: [queryTypeMiddleware],
  routeConfig: routeConfig,
  renderError: ({ error }) => (
    <div>{error.status === 404 ? "Not found" : "Error"}</div>
  ),
});

export default function Router() {
  return <FarceRouter resolver={new Resolver(enviroment)} />;
}
